import './App.css';
import { Suspense } from 'react';
import { BrowserRouter, Route, Routes, useParams } from 'react-router-dom';
import { Navigate, Outlet } from 'react-router-dom';
// import Header from "./components/Header/Header";
import Home from './components/Home/Home';
import IndexxSwap from './components/IndexxSwap/IndexxSwap';
import BuySell from './components/BuySell/BuySell';
import Help from './components/Help/Help';
import Intro from './components/Help/Intro';
import Team from './components/Help/Team';
import ContactUs from './components/Help/ContactUs';
import TradeToEarn from './components/TradeToEarn/TradeToEarn';
import BuySellLogin from './components/BuySell/BuySellLogin';
import BSWallet from './components/BuySell/BSWallet';
// import BuySellLoggedVerfication from './components/BuySell/BuySellLoggedVerfication';
import BuySellLoggedWelcome from './components/BuySell/BuySellLoggedWelcome';
import TradeChart from './components/TradeChart/TradeChart';
import BugReport from './components/TaskCenter/BugReport';
import Markets from './components/Markets/Markets';
import IndexBlog from './components/IndexBlog/IndexBlog';
import HowItWorks from './components/HowItWorks/HowItWorks';
import HowCentralized from './components/HowItWorks/howCentralized';
import HowTokens from './components/HowItWorks/howTokens';
import HowTradeToEarn from './components/HowItWorks/howTradeToEarn';
import TaskCenter from './components/TaskCenter/TaskCenter';
import BSWithdrawMain from './components/BSDepositWithdraw/BSWithdrawMain';
import BSDepositWithdarwSelect from './components/BSDepositWithdraw/BSDepositWithdarwSelect';
import BSWithdrawInfo from './components/BSDepositWithdraw/BSWithdrawInfo';
import BSDWAmount from './components/BSDepositWithdraw/BSDWAmount';
import BSDWRecorded from './components/BSDepositWithdraw/BSDWRecorded';
import BuySellGetStartedLayout from './components/BuySell/BuySellGetStartedLayout';
import BSDepositCryproLayout from './components/BSDeposit/BSDepositCryproLayout';
import BSTransactionHistoryLayout from './components/BSTransactionHistory/BSTransactionHistoryLayout';
import BSDepositFiatLayout from './components/BSDeposit/BSDepositFiatLayout';
import BSWithdrawCryptoLayout from './components/BSDepositWithdraw/BSWithdrawCryptoLayout';
import IndexxTokens from './components/IndexxTokens/IndexxTokens';
import ComingSoon from './components/ComingSoon/ComingSoon';
import HeaderNew from './components/Header/HeaderNew';
import About from './components/About/About';
import Account from './components/AccountSettings/Account';
// import BSDashhboard from './components/BuySell/BSDashboard';
import SecurityChange from './components/AccountSettings/SecurityChange';
import SecurityChangeUpdated from './components/AccountSettings/SecurityChangeUpdated';
// import Blockpass from './components/Blockpass/Blockpass';
import BlockpassLink from './components/Blockpass/BlockpassLink';
import VerifyWithIndexx from './components/KYC/VerifyWithIndexx';
import VerifyWithKyb from './components/KYB/VerifyWithKyb';
// import { useEffect, useState } from 'react';
// import { decodeJWT, getUserDetails } from '../src/services/api';

// import Header from './components/Header/Header';
// import BuySellGetStarted from './components/BuySell/BuySellGetStarted';
// import BuySellEmailAuth from './components/BuySell/BuySellEmailAuth';
// import BuySellSecureSteps from './components/BuySell/BuySellSecureSteps';
// import BuySellMobiAuth from './components/BuySell/BuySellMobiAuth';
// import BuySellmobiVerfication from './components/BuySell/BuySellmobiVerfication';
import ScrollToTop from './utils/ScrollToTop';

import Notification from './components/Notifications/Notification';
import AllNotification from './components/Notifications/AllNotification';
import Activity from './components/Notifications/Activity';
import SystemMsg from './components/Notifications/SystemMsg';
import Career from './components/Careers/Career';
import WelcomePage from './components/WelcomePage';
import ImportTokens from './components/ImportTokens/ImportTokens';
import BSOrderHistoryLayout from './components/BSOrderHistory/BSOrderHistoryLayout';
import BuySellLoginContentHive from './components/BuySell/BuySellLoginContentHive';
import RedeemStock from './components/RedeemStock/RedeemStock';
import CaptainDash from './components/Dashboard/Captainbee/CaptainDash';
import CaptainProfile from './components/Dashboard/Captainbee/CaptainProfile';
import MyBees from './components/Dashboard/Captainbee/MyBees/MyBees';
import BeeDash from './components/Dashboard/Captainbee/MyBees/BeeDash';
import CaptainResource from './components/Dashboard/Captainbee/CaptainResource/CaptainResource';
import CaptainResourceManagement from './components/Dashboard/Captainbee/CaptainResource/CaptainResourceManagement';
import CaptainResourceTechnical from './components/Dashboard/Captainbee/CaptainResource/CaptainResourceTechnical';
import CaptainResourceLegal from './components/Dashboard/Captainbee/CaptainResource/CaptainResourceLegal';
import CaptainResourceAccounting from './components/Dashboard/Captainbee/CaptainResource/CaptainResourceAccounting';
import HoneyCombComingSoon from './components/ComingSoon/HoneyCombComingSoon';
import BeeProfile from './components/Dashboard/Honeybee/BeeProfile';
import MyCaptain from './components/Dashboard/Honeybee/MyCaptain/MyCaptain';
import HoneyCombComingSoonBees from './components/ComingSoon/HoneyCombComingSoonBees';
import BeeDash2 from './components/Dashboard/Honeybee/MyBees/BeeDash2';
import BuySellGetStartedLayoutHoneyBee from './components/BuySell/BuySellGetStartedLayoutHoneyBee';
import BuySellLoginHoneyBee from './components/BuySell/BuySellLoginHoneyBee';
import PowerPack from './components/PowerPack/PowerPack';
import PowerPackCopy from './components/PowerPack - Copy/PowerPack';
import AffiliateProgram from './components/AffiliateProgram';
import PaymentSuccess from './components/PowerPack/PaymentSuccess';
import HoneyComb from './components/Dashboard/Captainbee/HoneyComb';
import TeamCaptainDash from './components/Dashboard/Captainbee/TeamCaptainBees/TeamCaptainDash';
import LeaderCaptain from './components/Dashboard/Captainbee/LeaderCaptain/LeaderCaptain';

import LottoHome from './components/Lottery/LottoHome';
import { useTheme } from '@mui/material/styles';

// import CareerSoon from './components/Careers/CareerSoon';
import { ThemeProvider } from '@mui/material';
import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { useState, useEffect, useMemo } from 'react';
import BSStakingHistoryLayout from './components/BSStakingHistory/BSStakingHistoryLayout';
import Bridge from './components/Bridge/Bridge';
import CaptainResourceSales from './components/Dashboard/Captainbee/CaptainResource/CaptainResourceSales';
import Footer from './components/Footer/Footer';
import { decodeJWT, getCaptainBeeByEmail, loginWithToken } from './services/api';
import ComingSoonETF from './components/ComingSoon/ComingSoonETF';
import PowerPackHeader from './components/PowerPack/PowerPackHeader/PowerPackHeader';
import SubscribeSuccess from './components/PowerPack/SubscribeSuccess';
import HorizontalLinearStepper2 from './components/Send/HorizontalLinearStepper2';
import BuySellVerifyEmail from './components/BuySell/BuySellVerifyEmail';
import EliteClub from './components/EliteClub/EliteClub';
import EliteLearnMore from './components/EliteClub/EliteLearnMore';
import SecondaryHeader from './SecondaryHeader';
import Payment from './components/Send/Payment';
import PaymentWire from './components/Send/PaymentWire';
import CaptainGreetCard from './components/Dashboard/Captainbee/CaptainGreetCard';
import PaymentVenmo from './components/Send/PaymentVenmo';
import HeaderTest from './components/Header_test';
import { ThemeContext } from './utils/themeContext';
import PowerPackInitial from './components/PowerPackInitial';
import PowerPackCaptainSecond from './components/PowerPackInitial/PowerPackCaptionSecond';
import PowerPackHoneySecond from './components/PowerPackInitial/PowerPackHoneySecond';
import HiveForgotPassword from './components/BuySell/HiveForgotPassword';
import ThemeContextUpdated from './utils/ThemeContextUpdated.jsx';
import ThemeToggler from './components/ThemeToggler/index.js';
import Login from './pages/auth/LoginEmail/index';
import LoginPassword from './pages/auth/LoginPassword';
import ResetPass from './pages/auth/ResetPassword';
import SignUpEmailPage from './pages/auth/Signup/EmailOrPhone';
import SignUpPhonePage from './pages/auth/Signup/SigupPhonePage';
import SignUpEmailVerificationPage from './pages/auth/Signup/EmailVerification';
import CreatePasswordPage from './pages/auth/Signup/CreatePassword';
import RefferalPage from './pages/auth/Signup/Refferal';
import SelectRolePage from './pages/auth/Signup/SelectRole';
import BuySellPage from './pages/BuySell';
import AssetsPage from './pages/Assets';
import StakingPage from './pages/Staking';
import DepositSelectCurrency from './pages/deposit/DepositSelectCurrency';
import DepositEnterAmount from './pages/deposit/DepositEnterAmount';
import DepositAddAccountInfo from './pages/deposit/AddAcountInfo';
import WithdrawAddAccountInfo from './pages/withdraw/WithdrawInfo';
import WithdrawEnterAmount from './pages/withdraw/WithdrawEnterAmount';
import WithdrawTransferMoney from './pages/withdraw/WithdrawTransferMoney';
import WithdrawSuccessPage from './pages/withdraw/WithdrawSuccess';
import DashboardPage from './pages/Dashboard';
import DepositSelectCoin from './pages/depositCrypto/DepositSelectCoin';
import DepositCryptoChange from './pages/depositCrypto/DepositCryptoChange';
import DepositCryptoSuccessPage from './pages/depositCrypto/DepositSuccess';
import WithdrawCryptoSuccessPage from './pages/withdrawCrypto/WitdrawCryptoSuccess';
import WithdrawCryptoSelectCoin from './pages/withdrawCrypto/WithdrawCryptoSelectCoin';
import ReferralPage from './pages/Refferal';
import PaymentACH from './components/Send/PaymentACH';
import RedeemPage from './pages/Redeem/Redeem';
import CreateCardPage from './pages/Redeem/CreateCard';
import SendCardPage from './pages/Redeem/SendCard';
import SendCardSuccessfulPage from './pages/Redeem/SendCardSuccessfull';
import PaypalPartnershipPage from './pages/PaypalPartnership';
import ConvertPage from './pages/Convert';
import NewAdvancedRealTimeChartComponent from './components/Graphs/NewTradingView';
import MarketsPage from './pages/Markets';
import SmartCryptoPage from './pages/SmartCrypto';
import SmartCryptoOldPage from './pages/SmartCryptoold';
import PlanDetails from './components/updated/SmartCrypto/PlanDetails';
import NotFound from './pages/NotFound';
import GiftShoppingHistoryPage from './pages/GiftShoppingHistory';
import HowToCreateBuySellPage from './pages/HowToCreateBuySell';
import SmartAPYPage from './pages/SmartAPY';
import HowItWorksSmartAPY from './pages/HowItWorksSmartAPY';
import SmartApyCalPage from './pages/SmartApyCal';
import CryptoTreasuryPage from './pages/CryptoTreasury';
import PerformancePage from './pages/PerformancePage';
import SupportCenter from './pages/SupportCenter';
import FaqsPage from './pages/Faqs';

// P2P Trading Components
import P2PDashboard from './components/P2P/P2PDashboard';
import OffersBrowse from './components/P2P/OffersBrowse';
import OfferDetails from './components/P2P/OfferDetails';
import TradesManagement from './components/P2P/TradesManagement';
import TradeDetails from './components/P2P/TradeDetails';
import P2PPayPalPayment from './components/P2P/P2PPayPalPayment';
import OfferManagement from './components/P2P/OfferManagement';
// import BuySellAllLogin from "./components/BuySell/BuySellAllLogin";

const TradingViewPage = () => {
  const { coin } = useParams<{ coin: string }>(); // extract the coin parameter from the URL
  return <NewAdvancedRealTimeChartComponent coin={String(coin)} />;
};

const BLOCKED_EMAILS = ['banks144@yahoo.com'];

function App() {
  // Evict blocked users synchronously before any auth state is read
  const storedEmail = localStorage.getItem('email');
  if (storedEmail && BLOCKED_EMAILS.includes(storedEmail.toLowerCase().trim())) {
    ['email', 'user', 'userType', 'access_token', 'refresh_token', 'redirected', 'username'].forEach(
      (key) => localStorage.removeItem(key)
    );
  }

  const theme = useTheme();
  const [userLogged, setUserLogged] = useState('normal'); // Set the user's type
  const [signInTokenProcessing, setSignInTokenProcessing] = useState(false);

  useEffect(() => {
    const initialLoader = document.querySelector('.initial-loader');
    if (initialLoader) {
      initialLoader.remove();
    }
  }, []);

  useEffect(() => {
    const user =
      localStorage.getItem('userlogged') !== undefined
        ? setUserLogged(String(localStorage.getItem('userlogged')))
        : setUserLogged('normal');
  }, []);

  useEffect(() => {
    const handleStorageChange = (event: any) => {
      // console.log(event);
      if (setUserLogged !== event.currentTarget.localStorage.userlogged)
        setUserLogged(event.currentTarget.localStorage.userlogged);
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const signInToken = params.get('signInToken');
    if (!signInToken) return;
    if (localStorage.getItem('redirected') === 'true') return;

    let isCancelled = false;
    const performTokenLogin = async () => {
      setSignInTokenProcessing(true);
      try {
        const res = await loginWithToken(signInToken);
        if (res?.status !== 200) {
          console.warn('signInToken login did not return 200:', res);
          return;
        }

        const decoded = decodeJWT(res.data.access_token);

        if (BLOCKED_EMAILS.includes(String(decoded?.email).toLowerCase().trim())) {
          return;
        }

        localStorage.setItem('email', decoded?.email ?? '');
        localStorage.setItem('user', decoded?.email ?? '');
        localStorage.setItem('userType', decoded?.userType ?? '');
        localStorage.setItem('access_token', res.data.access_token);
        localStorage.setItem('refresh_token', res.data.refresh_token);
        localStorage.setItem('redirected', 'true');

        if (decoded?.userType === 'CaptainBee' && decoded?.email) {
          const beeResponse = await getCaptainBeeByEmail(String(decoded.email));
          localStorage.setItem('username', beeResponse?.data?.Username ?? '');
        }

        params.delete('signInToken');
        const newSearch = params.toString();
        const newUrl = `${window.location.pathname}${newSearch ? `?${newSearch}` : ''}`;
        window.history.replaceState(null, '', newUrl);

        if (!isCancelled) {
          window.location.reload();
        }
      } catch (error) {
        console.error('Failed to log in with signInToken', error);
      } finally {
        setSignInTokenProcessing(false);
      }
    };

    performTokenLogin();

    return () => {
      isCancelled = true;
    };
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const signInToken = params.get('signInToken');
    if (!signInToken) return;
    if (localStorage.getItem('redirected') === 'true') return;

    let isCancelled = false;
    const performTokenLogin = async () => {
      try {
        const res = await loginWithToken(signInToken);
        if (res?.status !== 200) {
          console.warn('signInToken login did not return 200:', res);
          return;
        }

        const decoded = decodeJWT(res.data.access_token);

        if (BLOCKED_EMAILS.includes(String(decoded?.email).toLowerCase().trim())) {
          return;
        }

        localStorage.setItem('email', decoded?.email ?? '');
        localStorage.setItem('user', decoded?.email ?? '');
        localStorage.setItem('userType', decoded?.userType ?? '');
        localStorage.setItem('access_token', res.data.access_token);
        localStorage.setItem('refresh_token', res.data.refresh_token);
        localStorage.setItem('redirected', 'true');

        if (decoded?.userType === 'CaptainBee' && decoded?.email) {
          const beeResponse = await getCaptainBeeByEmail(String(decoded.email));
          localStorage.setItem('username', beeResponse?.data?.Username ?? '');
        }

        params.delete('signInToken');
        const newSearch = params.toString();
        const newUrl = `${window.location.pathname}${newSearch ? `?${newSearch}` : ''}`;
        window.history.replaceState(null, '', newUrl);

        if (!isCancelled) {
          window.location.reload();
        }
      } catch (error) {
        console.error('Failed to log in with signInToken', error);
      }
    };

    performTokenLogin();

    return () => {
      isCancelled = true;
    };
  }, []);

  const PrivateRoutes = () => {
    const isAuthenticated =
      localStorage.getItem('access_token') !== undefined &&
      localStorage.getItem('access_token') !== null;
    const isAllowed =
      localStorage.getItem('userType') === 'CaptainBee' &&
      localStorage.getItem('haspp') === 'false';

    const params = new URLSearchParams(window.location.search);
    const defaultSignInToken = params.get('signInToken');

    if (isAuthenticated && !isAllowed) {
      return <Outlet />;
    } else if (!isAuthenticated) {
      if (defaultSignInToken) {
        if (signInTokenProcessing) {
          return (
            <div className="sign-in-token-loader">
              Please wait, signing you in...
            </div>
          );
        }
        // allow effect to continue trying; show nothing to avoid redirect
        return null;
      }
      if (
        window.location.hostname === 'cex.indexx.ai' &&
        window.location.pathname === '/wallet/smart-crypto'
      ) {
        window.location.href = `https://indexx.ai/auth/login?redirectWebsiteLink=exchange`;
        return null; // Prevent further rendering
      }
      return <Navigate to="/update/home/" />;
    }

    // if (isAllowed) {
    //   return <Navigate to="/indexx-exchange/power-pack" />;
    // }
    return <Outlet />;
  };

  console.log(window.location.pathname, 'path');

  return (
    <ThemeContextUpdated>
      <div>
        {/* <ThemeToggler /> */}
        <BrowserRouter>
          {/* <Headers /> */}
          <ScrollToTop />
          {/* <HeaderNew /> */}
          <Suspense
            fallback={
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100vh',
                  fontSize: '18px',
                  color: 'var(--body_color)',
                }}
              >
                Loading...
              </div>
            }
          >
            <HeaderTest />
          </Suspense>

          {/* <SecondaryHeader /> */}
          <Suspense
            fallback={
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '50vh',
                  fontSize: '16px',
                  color: 'var(--body_color)',
                }}
              >
                Loading page...
              </div>
            }
          >
            <Routes>
              <Route path="/" element={<Navigate to="/update/home/" />} />
              <Route
                path="/paypal-partnership-with-indexx"
                element={<PaypalPartnershipPage />}
              />
              <Route path="/convert/*" element={<ConvertPage />} />
              <Route path="/referral" element={<ReferralPage />} />
              <Route path="/redeem" element={<RedeemPage />} />
              <Route path="/redeem/create-card" element={<CreateCardPage />} />
              <Route
                path="/redeem/shopping-history"
                element={<GiftShoppingHistoryPage />}
              />
              <Route
                path="/redeem/how-to-create-buy-sell"
                element={<HowToCreateBuySellPage />}
              />
              <Route path="/redeem/send-card" element={<SendCardPage />} />
              <Route
                path="/redeem/send-card-successful"
                element={<SendCardSuccessfulPage />}
              />
              <Route path="/smart-crypto" element={<SmartCryptoPage />} />
              <Route path="/support-center" element={<SupportCenter />} />
              <Route path="/faqs/:id" element={<FaqsPage />} />
              <Route
                path="/smart-crypto/plan-detail/:name"
                element={<PlanDetails />}
              />
              <Route
                path="/indexx-exchange/market-data"
                element={<MarketsPage />}
              />
              <Route path="/smart-apy" element={<SmartAPYPage />} />
              <Route
                path="/smart-apy-calculator"
                element={<SmartApyCalPage />}
              />
              <Route
                path="/smart-apy-how-it-works"
                element={<HowItWorksSmartAPY />}
              />
              <Route path="/crypto-treasury" element={<CryptoTreasuryPage />} />
              <Route element={<PrivateRoutes />}>
                <Route path="/wallet/overview" element={<AssetsPage />} />
                <Route path="/wallet/nugget" element={<AssetsPage />} />
                <Route path="/wallet/crypto" element={<AssetsPage />} />
                <Route path="/wallet/fiat" element={<AssetsPage />} />
                <Route path="/wallet/ai-engine-investment" element={<AssetsPage />} />
                <Route path="/wallet/smart-crypto" element={<AssetsPage />} />
                <Route path="/wallet/ai-engine-investment" element={<AssetsPage />} />
                <Route path="/wallet/iusd+" element={<AssetsPage />} />
                <Route
                  path="/wallet/demo-smart-crypto"
                  element={<AssetsPage />}
                />

                <Route path="/smart-cryptos" element={<SmartCryptoOldPage />} />

                {/* <Route
                path="/paypal-partnership-with-indexx"
                element={<PaypalPartnershipPage />}
              /> */}

                <Route
                  path="/indexx-exchange/send"
                  element={<HorizontalLinearStepper2 />}
                />
                <Route path="/dashboard" element={<DashboardPage />} />

                <Route
                  path="/indexx-exchange/buy-sell/staking"
                  element={<StakingPage />}
                  //element={<Staking />}
                />
                <Route
                  path="/deposit-select-currency"
                  element={<DepositSelectCurrency />}
                />
                <Route
                  path="/deposit-enter-amount"
                  element={<DepositEnterAmount />}
                />
                <Route
                  path="/deposit-add-account-information"
                  element={<DepositAddAccountInfo />}
                />
                <Route
                  path="/deposit-crypto-select-coin"
                  element={<DepositSelectCoin />}
                />
                <Route
                  path="/deposit-crypto-change-wallet"
                  element={<DepositCryptoChange />}
                />
                <Route
                  path="/deposit-crypto-success"
                  element={<DepositCryptoSuccessPage />}
                />
                <Route
                  path="/withdraw-crypto-success"
                  element={<WithdrawCryptoSuccessPage />}
                />
                <Route
                  path="/withdraw-crypto-select-coin"
                  element={<WithdrawCryptoSelectCoin />}
                />
                <Route
                  path="/withdraw-add-information"
                  element={<WithdrawAddAccountInfo />}
                />
                <Route
                  path="/withdraw-enter-amount"
                  element={<WithdrawEnterAmount />}
                />
                <Route
                  path="/withdraw-transfer-money"
                  element={<WithdrawTransferMoney />}
                />
                <Route
                  path="/withdraw-success"
                  element={<WithdrawSuccessPage />}
                />

                <Route
                  path="/indexx-exchange/power-hive"
                  element={<PowerPackInitial />}
                />
                <Route
                  path="/indexx-exchange/power-hive/honey-bee-selection"
                  element={<PowerPackHoneySecond />}
                />
                <Route
                  path="/indexx-exchange/power-hive/captain-bee-selection"
                  element={<PowerPackCaptainSecond />}
                />
                <Route
                  path="/indexx-exchange/dashboard"
                  element={<CaptainDash />}
                />
                <Route
                  path="/indexx-exchange/dashboard/capt-profile"
                  element={<CaptainProfile />}
                />
                <Route
                  path="/indexx-exchange/dashboard/capt-mybees"
                  element={<MyBees />}
                />
                <Route
                  path="/indexx-exchange/dashboard/capt-mybees/:id/:tab/:userType"
                  element={<BeeDash />}
                />
                <Route
                  path="/indexx-exchange/dashboard/capt-resource-mkt"
                  element={<CaptainResource />}
                />
                <Route
                  path="/indexx-exchange/dashboard/capt-resource-acc"
                  element={<CaptainResourceAccounting />}
                />
                <Route
                  path="/indexx-exchange/dashboard/capt-resource-leg"
                  element={<CaptainResourceLegal />}
                />
                <Route
                  path="/indexx-exchange/dashboard/capt-resource-tech"
                  element={<CaptainResourceTechnical />}
                />
                <Route
                  path="/indexx-exchange/dashboard/capt-resource-mgmt"
                  element={<CaptainResourceManagement />}
                />
                <Route
                  path="/indexx-exchange/dashboard/capt-resource-sales"
                  element={<CaptainResourceSales />}
                />
                <Route
                  path="/indexx-exchange/dashboard/honeycomb"
                  element={<HoneyComb />}
                />
                <Route
                  path="/indexx-exchange/dashboard/capt-mycaptains"
                  element={<TeamCaptainDash />}
                />
                <Route
                  path="/indexx-exchange/dashboard/capt-leader"
                  element={<LeaderCaptain />}
                />
                <Route
                  path="/indexx-exchange/dashboard/capt-greet"
                  element={<CaptainGreetCard />}
                />

                {/* Routes for Hive Member DashBoard   */}
                <Route
                  path="/indexx-exchange/bee-dashboard"
                  element={<BeeDash2 />}
                />
                <Route
                  path="/indexx-exchange/bee-dashboard/bee-profile"
                  element={<BeeProfile />}
                />
                <Route
                  path="/indexx-exchange/bee-dashboard/bee-captain"
                  element={<MyCaptain />}
                />
                <Route
                  path="/indexx-exchange/bee-dashboard/honeycomb"
                  element={<HoneyCombComingSoonBees />}
                />
              </Route>
              <Route path="/auth/login" element={<Login />} />
              <Route path="/auth/login-password" element={<LoginPassword />} />
              <Route path="/auth/reset-password" element={<ResetPass />} />
              <Route path="/auth/signup-email" element={<SignUpEmailPage />} />
              <Route path="/auth/signup-phone" element={<SignUpPhonePage />} />
              <Route
                path="/auth/signup-email-verification"
                element={<SignUpEmailVerificationPage />}
              />
              <Route
                path="/auth/signup-create-password"
                element={<CreatePasswordPage />}
              />
              <Route path="/auth/signup-referral" element={<RefferalPage />} />
              {/* <Route path="/auth/signup-role" element={<SelectRolePage />} /> */}

              <Route path="/update/home/*" element={<BuySellPage />} />
              <Route path="/update/home/etf-tokens" element={<BuySellPage />} />
              <Route
                path="/update/home/stock-token"
                element={<BuySellPage />}
              />

              <Route path="/indexx-exchange/lottery" element={<LottoHome />} />
              <Route
                path="/indexx-exchange/elite-club"
                element={<EliteClub />}
              />
              <Route
                path="/indexx-exchange/elite-learn/:id"
                element={<EliteLearnMore />}
              />

              <Route
                path="/indexx-exchange/payment-zelle"
                element={<Payment />}
              />
              <Route
                path="/indexx-exchange/payment-venmo"
                element={<PaymentVenmo />}
              />
              <Route
                path="/indexx-exchange/payment-wire"
                element={<PaymentWire />}
              />
              <Route
                path="/indexx-exchange/payment-ACH"
                element={<PaymentACH />}
              />

              {/* <Route
                path="/indexx-exchange/power-pack"
                element={<PowerPack />}
              /> */}
              <Route
                path="/indexx-exchange/powerpack-payment-success"
                element={<PaymentSuccess />}
              />
              <Route
                path="/indexx-exchange/subscribe-success"
                element={<SubscribeSuccess />}
              />

              <Route path="/indexx-exchange/bridge" element={<Bridge />} />

              <Route path="/indexx-exchange/lottery" element={<LottoHome />} />
              <Route
                path="/indexx-exchange/elite-club"
                element={<EliteClub />}
              />
              <Route
                path="/indexx-exchange/elite-learn/:id"
                element={<EliteLearnMore />}
              />

              <Route
                path="/indexx-exchange/affiliate"
                element={<AffiliateProgram />}
              />

              <Route
                path="/indexx-exchange/power-pack"
                element={<PowerPack type="captainBee" />}
              />

              <Route
                path="/indexx-exchange/captain-bee/power-pack"
                element={<PowerPackCopy type="captainBee" subType="power" />}
              />
              <Route
                path="/indexx-exchange/captain-bee/crypto-pack"
                element={<PowerPackCopy type="captainBee" subType="crypto" />}
              />

              <Route
                path="/indexx-exchange/honey-bee/action-pack"
                element={<PowerPackCopy type="honeyBee" subType="action" />}
              />
              <Route
                path="/indexx-exchange/honey-bee/token-pack"
                element={<PowerPackCopy type="honeyBee" subType="token" />}
              />
              <Route
                path="/indexx-exchange/powerpack-payment-success"
                element={<PaymentSuccess />}
              />
              <Route
                path="/indexx-exchange/subscribe-success"
                element={<SubscribeSuccess />}
              />

              <Route
                path="/indexx-exchange/buy-sell/staking"
                element={<StakingPage />}
              />
              <Route path="/indexx-exchange/bridge" element={<Bridge />} />

              <Route path="/indexx-exchange/kyc" element={<BlockpassLink />} />
              <Route path="/indexx-exchange/swap" element={<IndexxSwap />} />
              <Route
                path="/indexx-exchange/coming-soon-etf"
                element={<ComingSoonETF />}
              />
              <Route
                path="/indexx-exchange/coming-soon"
                element={<ComingSoon />}
              />
              <Route
                path="/indexx-exchange/import-indexx-tokens"
                element={<ImportTokens />}
              />
              <Route
                path="/indexx-exchange/tokens"
                element={<IndexxTokens />}
              />

        {/* P2P Trading Routes */}
        <Route path="/p2p" element={<P2PDashboard />} />
        <Route path="/p2p/offers" element={<OffersBrowse />} />
        <Route path="/p2p/offers/:offerId" element={<OfferDetails />} />
        <Route path="/p2p/offers/create" element={<OfferManagement />} />
        <Route path="/p2p/trades" element={<TradesManagement />} />
        <Route path="/p2p/trades/:tradeId" element={<TradeDetails />} />
        <Route path="/p2p/paypal-payment" element={<P2PPayPalPayment />} />

              <Route path="/indexx-exchange/buy-sell/*" element={<BuySell />} />
              <Route
                path="/indexx-exchange/buy-sell/for-honeybee/:id/*"
                element={<BuySell />}
              />
              <Route
                path="/indexx-exchange/buy-sell/login/*"
                element={<Navigate to="/update/home/" />}
              />

              <Route
                path="/indexx-exchange/buy-sell/login-honeybee/*"
                element={<BuySellLoginHoneyBee />}
              />
              <Route
                path="/indexx-exchange/buy-sell/hive-login"
                element={<BuySellLoginContentHive />}
              />
              <Route
                path="/indexx-exchange/buy-sell/hive-login/forgot-password"
                element={<HiveForgotPassword />}
              />
              <Route
                path="/indexx-exchange/buy-sell/wallet"
                element={<AssetsPage />}
              />
              <Route
                path="/indexx-exchange/buy-sell/withdraw-crypto/*"
                element={<BSWithdrawCryptoLayout />}
              />
              <Route
                path="/indexx-exchange/buy-sell/withdraw"
                element={<BSWithdrawMain />}
              >
                <Route index element={<BSDepositWithdarwSelect />} />
                <Route path="info" element={<BSWithdrawInfo />} />
                <Route path="amount" element={<BSDWAmount />} />
                <Route path="recorded" element={<BSDWRecorded />} />
              </Route>
              <Route
                path="/indexx-exchange/buy-sell/deposit-crypto/*"
                element={<BSDepositCryproLayout />}
              />
              <Route
                path="/indexx-exchange/redeem-stock"
                element={<RedeemStock />}
              />
              <Route
                path="/indexx-exchange/buy-sell/deposit-fiat/*"
                element={<BSDepositFiatLayout />}
              />
              <Route
                path="//indexx-exchange/buy-sell/performance-history"
                element={<PerformancePage />}
              />

              <Route
                path="/indexx-exchange/buy-sell/transaction-history/*"
                element={<BSTransactionHistoryLayout />}
              />
              <Route
                path="/indexx-exchange/buy-sell/staking-history/*"
                element={<BSStakingHistoryLayout />}
              />
              <Route
                path="/indexx-exchange/buy-sell/order-history/*"
                element={<BSOrderHistoryLayout />}
              />
              <Route
                path="/indexx-exchange/buy-sell/get-started/*"
                element={<BuySellGetStartedLayout />}
              />
              <Route
                path="/indexx-exchange/buy-sell/get-started-honeybee/*"
                element={<BuySellGetStartedLayoutHoneyBee />}
              />
              <Route
                path="/indexx-exchange/buy-sell/welcome"
                element={<BuySellLoggedWelcome />}
              />
              <Route
                path="/indexx-exchange/trade-to-earn"
                element={<TradeToEarn />}
              />
              <Route
                path="/indexx-exchange/trading-view/:coin"
                element={<TradingViewPage />}
              />
              <Route
                path="/indexx-exchange/reward-center"
                element={<TaskCenter />}
              />
              <Route
                path="/indexx-exchange/report-bug"
                element={<BugReport />}
              />
              <Route
                path="/indexx-exchange/how-it-works"
                element={<HowItWorks />}
              />
              <Route
                path="/indexx-exchange/how-it-works/centralized"
                element={<HowCentralized />}
              />
              <Route
                path="/indexx-exchange/how-it-works/tradetoearn"
                element={<HowTradeToEarn />}
              />
              <Route
                path="/indexx-exchange/how-it-works/tokens"
                element={<HowTokens />}
              />
              <Route path="/indexx-exchange/charts" element={<Home />} />
              <Route path="/indexx-exchange/charts" element={<Home />} />
              {localStorage.getItem('user') ? (
                <Route path="/indexx-exchange/markets" element={<Markets />} />
              ) : (
                <Route path="/indexx-exchange/markets" element={<Markets />} />
              )}
              <Route path="/indexx-exchange/trade" element={<TradeChart />} />
              <Route path="/indexx-exchange/about" element={<About />} />
              <Route path="/indexx-exchange/help" element={<Help />}>
                <Route index element={<Intro />} />
                <Route path="team" element={<Team />} />
                <Route path="contact" element={<ContactUs />} />
              </Route>
              <Route
                path="/indexx-exchange/notification"
                element={<Notification />}
              >
                <Route index element={<AllNotification />} />

                <Route path="Activities" element={<Activity />} />
                <Route path="system" element={<SystemMsg />} />
              </Route>
              <Route path="/indexx-exchange/careers" element={<Career />} />
              <Route path="/indexx-exchange/blog" element={<IndexBlog />} />
              <Route
                path="/indexx-exchange/welcome"
                element={<WelcomePage />}
              />
              <Route path="/indexx-exchange/account" element={<Account />} />
              <Route
                path="/indexx-exchange/account/email-auth"
                element={<BuySellVerifyEmail />}
              />
                <Route
                path="/indexx-exchange/verify-with-indexx"
                element={<VerifyWithIndexx />}
              />
              <Route
                path="/indexx-exchange/kyb-verification"
                element={<VerifyWithKyb />}
              />
              <Route
                path="/indexx-exchange/change-password"
                element={<SecurityChangeUpdated />}
              />
              <Route
                path="/indexx-exchange/change-password-updated"
                element={<SecurityChangeUpdated />}
              />

              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
        <Suspense fallback={<div>Loading footer...</div>}>
          <Footer />
        </Suspense>
        <div id="globalnav-curtain" className="globalnav-curtain"></div>
      </div>
    </ThemeContextUpdated>
  );
}

// function External() {
//
//     window.location.href = 'http://localhost:3002/';
//     return null;
// }

export default App;
